import styled, { keyframes } from 'styled-components/macro';
import { Spinner2 } from 'styled-icons/evil';

export const Download = styled.div`
  width: 270px;
  height: 40px;
  background-color: ${({ disabled, theme }) =>
    disabled ? theme.gray : theme.dark4};
  color: ${({ disabled, theme }) =>
    disabled ? 'rgba(0,0,0,0.7)' : theme.white} !important;
  position: fixed;
  bottom: 0;
  left: calc(50% - 125px);
  right: calc(50% + 125px);
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  display: flex;
  z-index: 500;
  > div {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: ${({ theme }) => theme.primaryFontBold};

    &:first-child {
      width: calc(100% - 40px);
      font-size: ${({ theme }) => theme.paragraph}px;
      text-align: center;
      padding: 8px 5px 5px;
      line-height: 14px;
    }

    &:last-child {
      width: 40px;
      background-color: ${({ theme, disabled, competition }) =>
        (competition === 2 && !disabled && theme.turquoise) ||
        (competition === 1 && !disabled && theme.coral) ||
        (disabled && theme.gray)};
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    width: 100%;
    top: 99px;
    left: 0;
    right: 0;
  }
`;

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const Spinner = styled(Spinner2)`
  color: ${({ theme }) => theme.whiteWithOpacity};
  animation: ${rotate} 0.8s linear infinite;
`;
